<template>
  <div class="w-full overflow-x-scroll">
    <table class="w-full global-table">
      <thead class="">
        <slot name="thead"></slot>
      </thead>
      <tbody>
        <slot name="tbody"></slot>
      </tbody>
    </table>
    <vs-pagination
      v-if="withPagination"
      class="mt-5"
      :total="totalPage"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
export default {
  props: {
    totalPage: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    withPagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      page: this.currentPage,
    };
  },
  watch: {
    page: {
      handler() {
        this.$emit("reloadData", this.page);
      },
    },
    currentpage: {
      handler() {
      },
    },
  },
};
</script>

<style lang="scss">
.global-table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
</style>
